export default __webpack_public_path__ + "static/media/chewron.f3fff088.svg";